import { render } from "./column-saving-buttons.vue?vue&type=template&id=03e70ac8&ts=true"
import script from "./column-saving-buttons.ts?vue&type=script&lang=ts&external"
export * from "./column-saving-buttons.ts?vue&type=script&lang=ts&external"

import "./column-saving-buttons.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__